export interface LoyaltyLandingPageBenefitDetails {
  title: React.ReactNode
  description: React.ReactNode
  image: App.Image
  benefitCode: App.LoyaltyBenefitType
  enabled: boolean
}

export type LoyaltyLandingPageBenefitCopy = Record<
  App.LoyaltyBenefitType,
  LoyaltyLandingPageBenefitDetails | undefined
>

export const getLoyaltyLandingPageBenefitCopy = (
  enabledBenefits: App.LoyaltyRegionEnabledBenefits,
): LoyaltyLandingPageBenefitCopy => {
  return {
    hotel_upgrade: {
      title: 'Upgrade your stay',
      description: 'Enjoy complimentary room and package upgrades on select offers. Your upgrade is guaranteed as soon as you book, ensuring a seamless check-in with no surprises.',
      image: {
        id: 'wfzka1j5ru5d5e7hc9u',
        title: 'Free room and package upgrades',
      },
      benefitCode: 'hotel_upgrade',
      enabled: enabledBenefits.hotel_upgrade,
    },
    airport_transfer: {
      title: 'Travel in style with private chauffeur transfers',
      description: 'Start and end your journey smoothly with free private airport transfers in select destinations. No stress, just seamless service.',
      image: {
        id: '0qt5tc9nvf1qd3f0t5fe',
        title: 'Free airport chauffeur service',
      },
      benefitCode: 'airport_transfer',
      enabled: enabledBenefits.airport_transfer,
    },
    lounge_pass: {
      title: 'Lounge in comfort before your flight',
      description: 'Unwind with a drink, a bite to eat, and a quiet space to relax, the perfect start to your Luxury Escape.',
      image: {
        id: 'rq13k5lzgr8oxoz3a2',
        title: 'Free airport lounge passes',
      },
      benefitCode: 'lounge_pass',
      enabled: enabledBenefits.lounge_pass,
    },
    phone_support: {
      title: 'Priority support',
      description: 'Skip the queue with 24/7 access to our dedicated support team, always here to help, whenever you need us.',
      image: {
        id: 'kf3r6fahlubu2yb1htkgb',
        title: 'Faster, priority support',
      },
      benefitCode: 'phone_support',
      enabled: enabledBenefits.phone_support,
    },
    travelshoot_credit: {
      title: 'Discounted photoshoots',
      description: 'Capture your escape in style with exclusive discounts on professional Travelshoot photo sessions at your destination.',
      image: {
        id: 'r1z816jjifeqb5hwk50o',
        title: 'Pro photos on your trip',
      },
      benefitCode: 'travelshoot_credit',
      enabled: enabledBenefits.travelshoot_credit,
    },
    tour_exp_credit: {
      title: 'Extras on your tour',
      description: 'Unlock credits for exclusive add-ons, from relaxing massages to local food experiences.',
      image: {
        id: '69vg83q7obl8xw4x1ac',
        title: 'Extras on your tour',
      },
      benefitCode: 'tour_exp_credit',
      enabled: enabledBenefits.tour_exp_credit,
    },
    discounted_insurance: {
      title: 'Discounted travel insurance',
      description: 'Save on Travel & Cancellation Protection',
      image: {
        id: '36fmxwdnmim0b53p9x7',
        title: 'Travel & Cancellation Protection',
      },
      benefitCode: 'discounted_insurance',
      enabled: enabledBenefits.discounted_insurance,
    },
    early_access: undefined,
    hidden_access: undefined,
  }
}
